import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseRequestPolicy, HttpHeaders } from '@azure/ms-rest-js';
export var CustomHeaderPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(CustomHeaderPolicy, _BaseRequestPolicy);

  var _super = _createSuper(CustomHeaderPolicy);

  /* eslint-disable  @typescript-eslint/parameter-properties -- property */
  function CustomHeaderPolicy(nextPolicy, options, headerKey, headerValue) {
    var _this;

    _classCallCheck(this, CustomHeaderPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.nextPolicy = nextPolicy;
    _this.options = options;
    _this.headerKey = headerKey;
    _this.headerValue = headerValue;
    return _this;
  }
  /* eslint-enable */


  _createClass(CustomHeaderPolicy, [{
    key: "sendRequest",
    value: async function sendRequest(request) {
      this.addCustomHeader(request);
      return this.nextPolicy.sendRequest(request);
    }
  }, {
    key: "addCustomHeader",
    value: function addCustomHeader(request) {
      var copyRequest = request; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always falsy we need this condition

      if (!copyRequest.headers) {
        copyRequest.headers = new HttpHeaders();
      }

      if (!copyRequest.headers.get(this.headerKey) && this.headerValue) {
        copyRequest.headers.set(this.headerKey, this.headerValue);
      }
    }
  }]);

  return CustomHeaderPolicy;
}(BaseRequestPolicy);